import lcmApiClient from "./lcmApiClient";

import { extractNode, extractNodes } from "../extractors/nodesExtractor";
import { extractNodeTypes } from "../extractors/nodeTypesExtractor";

/* istanbul ignore next */
export async function findNodeTypes(filter: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().getAll("/node/types", filter);
  return extractNodeTypes(response, true);
}

export async function findAllAvailableNodeTypes(
  nodeId: $TSFixMe,
  filter: $TSFixMe,
) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const responseNodeTypes = await lcmApiClient().getAll("/node/types", filter);
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const responseTypeOptions = await lcmApiClient().getAll(
    `/nodes/${nodeId}/type-options`,
    filter,
  );
  (responseNodeTypes as $TSFixMe).node_types = (
    responseNodeTypes as $TSFixMe
  ).node_types
    .concat((responseTypeOptions as $TSFixMe).node_types)
    .filter(
      (nodeType: $TSFixMe, index: $TSFixMe, self: $TSFixMe) =>
        self.findIndex((t: $TSFixMe) => t.id === nodeType.id) === index,
    );
  return extractNodeTypes(responseNodeTypes, true);
}

/* istanbul ignore next */
export async function createNode(
  node: $TSFixMe,
  tenantId: $TSFixMe,
  parentId: $TSFixMe,
) {
  const param = {
    name: node.name,
    description: node.description,
    type: { id: node.type.id },
  };
  if (parentId) {
    (param as $TSFixMe).parent = { id: parentId };
  }
  if (tenantId) {
    (param as $TSFixMe).tenant = { id: tenantId };
  }
  const response = await lcmApiClient().post("/nodes", param);
  return (response as $TSFixMe).id;
}

export async function updateNode(nodeId: $TSFixMe, values: $TSFixMe) {
  await lcmApiClient().patch(`/nodes/${nodeId}`, values);
}

/* istanbul ignore next */
export async function loadNextNodes(url: $TSFixMe, filter = {}) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().get(url, filter);
  return {
    nodes: extractNodes(response),
    totalCount: (response as $TSFixMe).pagination.total_count,
    nextPageUrl: (response as $TSFixMe).pagination.next,
  };
}

// @deprecated
export async function loadNodes(filter = {}) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient(false).get("/nodes", filter);
  return {
    nodes: extractNodes(response),
    nextPageUrl: (response as $TSFixMe)?.pagination?.next,
  };
}

// @deprecated
export async function loadNode(id: $TSFixMe, parameters: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().get(`/nodes/${id}`, parameters);
  return extractNode(response);
}

/* istanbul ignore next */
export async function createNodeType(nodeType: $TSFixMe, tenantId: $TSFixMe) {
  const param = {
    name: nodeType.name,
  };
  if (tenantId) {
    (param as $TSFixMe).tenant = { id: tenantId };
  }
  const response = await lcmApiClient().post("/node/types", param);
  return (response as $TSFixMe).id;
}
